import React from 'react';

import './PageNotFound.scss';

const PageNotFound = () => (
  <div className="app">
    <div className="not-found-page page">
      <h1 className="four0four-title">404</h1>
      <h3 className="four0four-subtitle">You found a Glitch!</h3>
      <div className="image-container">
        <img className="four0four-image" src="https://thefoos-com2.s3.amazonaws.com/global/404_glitch.png" alt="" />
      </div>
      <p className="four0four-desc">This means you are looking for a page that doesn&rsquo;t exist.</p>
    </div>
  </div>
);

export default PageNotFound;
